import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { couponText } from './utils';
import { getCongratsDialogContentStyles } from '../styles/congrats-dialog-content-styles';
import { DefaultCurrencyCode, couponTypes, formatCost } from '../helpers';
import { CouponDetailsProps } from '../coupon-props';

export const CongratsDialogContent = (props) => {
  const {
    couponDetails,
    couponPlatformText,
    getCouponCurrencyCode,
  } = props;

  const classes = useDefaultStyles(getCongratsDialogContentStyles);
  const i18n = useContext(I18nContext);

  const couponDescription = useMemo(() => {
    if (!couponDetails) {
      return null;
    }
    const currency = getCouponCurrencyCode(couponDetails.CurrencyId) || DefaultCurrencyCode;
    const couponAmount = formatCost(couponDetails.CouponValue, i18n, currency);
    switch (couponDetails.CouponTypeId) {
      case couponTypes.Percent:
        return i18n.getString(
          _TL_('You now have {{ percentOff }}% off (up to {{ couponAmount }}) on your search advertising spend for {{ numberOfDays }} days.'),
          {
            percentOff: couponDetails.PercentOff,
            couponAmount,
            numberOfDays: couponDetails.LimitForDaysToUseFromCustomerCreation,
          }
        );
      default:
        return couponText({ i18n, couponDetails, currencyCode: currency });
    }
  }, [couponDetails, getCouponCurrencyCode, i18n]);

  return (
    <div className="coupon-congrats-dialog-content">
      <div>
        <Icon
          className={classNames(classes.completedIcon, 'completed-solid-icon')}
          iconName="CompletedSolid"
          aria-hidden="true"
        />
        {i18n.getString(_TL_('Your coupon has been applied!'))}
      </div>
      {couponDetails &&
        <div className={classNames(classes.couponContainer, 'coupon-container')}>
          <Icon
            className={classNames(classes.couponIcon, 'iconba-CouponSolid coupon-solid-icon')}
            iconName="CouponSolid"
            aria-hidden="true"
          />
          <div className={classNames(classes.couponContent, 'coupon-content')}>
            <div className={classNames(classes.couponText, 'coupon-text')}>
              {couponDescription}
            </div>
            <div className={classNames(classes.couponPlatform, 'coupon-platform')}>
              {couponPlatformText || i18n.getString(_TL_('This offer only applies to this account\'s ad spend and is valid across the Microsoft Advertising Network.'))}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

CongratsDialogContent.propTypes = {
  couponDetails: CouponDetailsProps,
  couponPlatformText: PropTypes.string,
  getCouponCurrencyCode: PropTypes.func,
};

CongratsDialogContent.defaultProps = {
  couponDetails: null,
  couponPlatformText: undefined,
  getCouponCurrencyCode: _.noop,
};
